module.exports = __webpack_public_path__ + "img/14.95c43a8d.png";